import React, { useState } from 'react';

const PropertySearch = ({ onSearch, initialFilters = {}, onReset }) => {
  
  const [filters, setFilters] = useState({
    location: initialFilters.location || '',
    minPrice: initialFilters.minPrice || '',
    maxPrice: initialFilters.maxPrice || '',
    bedrooms: initialFilters.bedrooms || ''
  });

  const handleInputChange = (e) => {
    const { name, value } = e.target;
    setFilters(prev => ({
      ...prev,
      [name]: value
    }));
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    onSearch(filters);
  };

  const handleReset = () => {
    setFilters({
      location: '',
      minPrice: '',
      maxPrice: '',
      bedrooms: ''
    });
    if (onReset) onReset();
  };

  return (
    <form onSubmit={handleSubmit} style={styles.form}>
      <div style={styles.inputGroup}>
        <input
          type="text"
          name="location"
          placeholder="Lokacija (npr. Zagreb, Split...)"
          value={filters.location}
          onChange={handleInputChange}
          style={styles.input}
        />
      </div>
      
      <div style={styles.inputGroup}>
        <input
          type="number"
          name="minPrice"
          placeholder="Min cijena (€)"
          value={filters.minPrice}
          onChange={handleInputChange}
          style={styles.input}
          min="0"
        />
        <input
          type="number"
          name="maxPrice"
          placeholder="Max cijena (€)"
          value={filters.maxPrice}
          onChange={handleInputChange}
          style={styles.input}
          min="0"
        />
      </div>
      
      <div style={styles.inputGroup}>
        <select 
          name="bedrooms" 
          value={filters.bedrooms} 
          onChange={handleInputChange}
          style={styles.select}
        >
          <option value="">Broj soba (sve)</option>
          <option value="1">1+ soba</option>
          <option value="2">2+ sobe</option>
          <option value="3">3+ sobe</option>
          <option value="4">4+ sobe</option>
        </select>
      </div>
      
      <div style={styles.buttonGroup}>
        <button type="submit" style={styles.searchButton}>
          Traži nekretnine
        </button>
        <button 
          type="button" 
          onClick={handleReset} 
          style={styles.resetButton}
        >
          Resetiraj
        </button>
      </div>
    </form>
  );
};

const styles = {
  form: {
    display: 'flex',
    flexDirection: 'column',
    gap: '1.5rem',
    padding: '1.5rem',
    backgroundColor: 'white',
    borderRadius: '8px',
    boxShadow: '0 2px 15px rgba(0,0,0,0.1)',
    margin: '2rem auto',
    maxWidth: '800px'
  },
  inputGroup: {
    display: 'flex',
    gap: '1rem',
    flexWrap: 'wrap'
  },
  input: {
    flex: 1,
    padding: '12px',
    border: '1px solid #ddd',
    borderRadius: '4px',
    fontSize: '1rem',
    minWidth: '200px'
  },
  select: {
    padding: '12px',
    border: '1px solid #ddd',
    borderRadius: '4px',
    fontSize: '1rem',
    width: '100%'
  },
  buttonGroup: {
    display: 'flex',
    gap: '1rem',
    justifyContent: 'center'
  },
  searchButton: {
    padding: '12px 24px',
    backgroundColor: '#4a6fa5',
    color: 'white',
    border: 'none',
    borderRadius: '4px',
    cursor: 'pointer',
    fontSize: '1rem',
    fontWeight: '600',
    flex: 1,
    transition: 'background-color 0.3s',
    '&:hover': {
      backgroundColor: '#3a5a80'
    }
  },
  resetButton: {
    padding: '12px 24px',
    backgroundColor: '#e0e0e0',
    color: '#333',
    border: 'none',
    borderRadius: '4px',
    cursor: 'pointer',
    fontSize: '1rem',
    fontWeight: '600',
    flex: 1,
    transition: 'background-color 0.3s',
    '&:hover': {
      backgroundColor: '#d0d0d0'
    }
  }
};

export default PropertySearch;